import { Component, inject } from '@angular/core';
import { ToastService } from '@core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  template: `
    <div class="toast-stack" aria-live="polite" aria-atomic="true">
      @for (t of toast.messages(); track t.id) {
        <div class="toast toast--{{ t.type }}" role="status">
          <span class="toast__dot"></span>
          <span class="toast__msg">{{ t.message }}</span>
          <button
            type="button"
            class="toast__close"
            aria-label="Dismiss"
            (click)="toast.dismiss(t.id)"
          >
            ×
          </button>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-stack {
        position: fixed;
        top: var(--space-5);
        right: var(--space-5);
        display: flex;
        flex-direction: column;
        gap: var(--space-2);
        z-index: 1000;
        max-width: 360px;
      }
      .toast {
        display: flex;
        align-items: center;
        gap: var(--space-3);
        padding: var(--space-3) var(--space-4);
        background: var(--color-surface);
        border: 1px solid var(--color-border);
        border-left-width: 4px;
        border-radius: var(--radius-md);
        box-shadow: var(--shadow-lg);
        animation: slide-in 0.18s ease;
      }
      .toast__dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex: none;
      }
      .toast__msg {
        flex: 1;
        font-size: 0.9rem;
      }
      .toast__close {
        background: none;
        border: none;
        font-size: 1.2rem;
        line-height: 1;
        color: var(--color-text-subtle);
      }
      .toast--success {
        border-left-color: var(--color-success);
      }
      .toast--success .toast__dot {
        background: var(--color-success);
      }
      .toast--error {
        border-left-color: var(--color-danger);
      }
      .toast--error .toast__dot {
        background: var(--color-danger);
      }
      .toast--info {
        border-left-color: var(--color-info);
      }
      .toast--info .toast__dot {
        background: var(--color-info);
      }
      @keyframes slide-in {
        from {
          opacity: 0;
          transform: translateX(12px);
        }
      }
    `,
  ],
})
export class ToastComponent {
  readonly toast = inject(ToastService);
}
